"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const LinkBehavior = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
  const {
    href,
    ...other
  } = props;
  // Map href (MUI) -> to (react-router)
  if (!href || href.match(/^https?:\/\//) || href.match(/^mailto:/)) {
    const {
      children,
      rel: _rel,
      target: _target,
      ...aOther
    } = other;
    const rel = _rel ? _rel : 'noopener noreferrer';
    const target = _target ? _target : '_blank';
    return /*#__PURE__*/_react.default.createElement("a", _extends({
      "data-testid": "link",
      ref: ref,
      href: href,
      rel: rel,
      target: target
    }, aOther), children);
  }
  return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, _extends({
    "data-testid": "router-link",
    ref: ref,
    to: href
  }, other));
});
LinkBehavior.propTypes = {
  href: _propTypes.default.oneOfType([_propTypes.default.shape({
    hash: _propTypes.default.string,
    pathname: _propTypes.default.string,
    search: _propTypes.default.string
  }), _propTypes.default.string])
};
var _default = exports.default = LinkBehavior;